import dayjs from '../plugins/dayjs.ts';

export function formatMilliseconds(mills: number, showSeconds?: boolean): string {
  const duration = dayjs.duration(mills);

  let result = `${
    duration.hours()
      .toString()
      .padStart(2, '0')
  }:${
    duration.minutes()
      .toString()
      .padStart(2, '0')
  }`;

  if (showSeconds) {
    result += `:${duration.seconds().toString().padStart(2, '0')}`;
  }

  return result;
}
